/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Outlook_Reply_All_Summary_TitleInputs */



/**
* | output |
* | --- |
* | "Reply all to email" |
*
* @param {Chat_Outlook_Reply_All_Summary_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_outlook_reply_all_summary_title = /** @type {((inputs?: Chat_Outlook_Reply_All_Summary_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Outlook_Reply_All_Summary_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Allen auf E-Mail antworten")
	return /** @type {LocalizedString} */ ("Reply all to email")
});